export default __webpack_public_path__ + "static/media/energy.7bf6b20d.svg";